import { z } from 'zod'

export const schema = z.object({
  price: z
    .object({
      amount: z.number().int(),
      currency: z.enum(['EUR']),
    })
    .nullable(),
  type: z.enum(['exact', 'from']).nullable(),
})

export type schemaType = z.infer<typeof schema>
